<template>
	<div class="c-multi-select t-margin--1-bottom-half" :id="id" :class="{'is-open': isOpen}">
		<button
			@click="toggleSelect()"
			@keydown="triggerKeyPress($event)"
			ref="trigger"
			class="c-multi-select__trigger"
			aria-haspopup="listbox"
			aria-expanded="false">
			<span class="c-multi-select__container">
				<span class="c-multi-select__label">{{label}}</span>
				<span class="c-multi-select__active">{{numSelectedItems}} {{countLabel}}</span>
			</span>
			<v-icon name="icon-arrow" size="xs" cssModifiers="c-multi-select__icon"></v-icon>
		</button>
		<ul
			class="c-multi-select__list"
			@focusout="toggleSelect()"
			@keydown="listKeyPress($event)"
			:aria-activedescendant="id + '-option-' + selectedIndex"
			ref="list"
			role="listbox"
			tabindex="-1">
			<li class="c-multi-select__option"
				v-for="(option, index) in options"
				:class="{'is-active': index === selectedIndex}"
				:key="index"
				:aria-selected="option.checked ? 'true' : 'false'"
				:aria-labelledby="id + '-label-' + index"
				:id="id + '-option-' + index"
				role="option">
					<input type="checkbox"
						:id="id + '-checkbox-' + index"
						:value="option.value"
						:checked="option.checked ? true : false"
						class="c-custom-checkbox__input">
					<label class="c-custom-checkbox__label c-multi-select__checkbox-label"
						@click.prevent="selectItem(index, option.value)"
						:class="{'is-active': option.checked}"
						:for="id + '-checkbox-' + index"
						:id="id + '-label-' + index">
						{{option.display}}
					</label>
			</li>
		</ul>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';

export default {
    name: 'VMultiSelect',
	components: {
		VIcon
	},
	props: {
		label: {
			type: String,
			default: null
		},
		options: {
			type: Array,
			default: () => []
		},
		id: {
			type: String
		}
	},
	data() {
		return {
			isOpen: false,
			readyToOpen: true,
			selectedIndex: 0,
			countLabel: 'valda',
			scrollPos: 0,
		}
	},
	computed: {
        numSelectedItems() {
            return this.options.filter((item) => {return item.checked}).length;
        },
		hasToggleAll() {
			return (this.options.filter((item) => {return item.toggleAll}).length === 1);
		},
		maxIndex() {
			return this.options.length - 1;
		}
    },
	methods: {
		/**
		 * Handle select list toggle
		 */
		toggleSelect() {
			if (this.isOpen) {
				this.isOpen = false;
				this.$refs.trigger.setAttribute('aria-expanded', 'false');
				this.$nextTick(() => {
					this.$refs.trigger.focus();
				});

				this.$emit('optionSelected', {id: this.id, options: this.options, hasToggleAll: this.hasToggleAll});

				this.readyToOpen = false;
				setTimeout(()=>{ this.readyToOpen = true; }, 200);
			} else if (!this.isOpen) {
				if (this.readyToOpen) {
					this.isOpen = true;
					this.$refs.trigger.setAttribute('aria-expanded', 'true');
					this.$nextTick(() => {
						this.$refs.list.focus();
					});
				}
			}
		},
		/**
		 * Handle option click
		 */
		selectItem(index) {
			let option = this.options[index];

			if (option.toggleAll) {
				/* Toggle all */
				if (this.numSelectedItems === this.options.length) {
					this.options.forEach((item) => {item.checked = false});
				} else if (this.numSelectedItems === 0) {
					this.options.forEach((item) => {item.checked = true});
				} else if (!option.checked) {
					this.options.forEach((item) => {item.checked = true});
				}
			} else {
				/* Check or uncheck */
				if (option.checked) {
					option.checked = false;
					if (this.hasToggleAll) {
						this.options[0].checked = false;
					}
				} else {
					option.checked = true;
				}
			}

			/* Count selected items and set label */
			//this.numSelectedItems = this.options.filter((item) => {return item.checked}).length;
			if (this.numSelectedItems === 1) {
				this.countLabel = 'vald';
			} else {
				this.countLabel = 'valda';
			}
		},
		/**
		 * Handle trigger keypress
		 */
		triggerKeyPress(event) {
			switch (event.keyCode) {
				case 40: /* Arrow down */
				case 27: /* Escape */
				case 32: /* Space */
					event.preventDefault();
					this.toggleSelect();
					break;
				default:
					break;
			}
		},
		/**
		 * Handle list keypress
		 */
		listKeyPress(event) {
			switch (event.keyCode) {
				case 40: /* Arrow down */
					event.preventDefault();
					if (this.selectedIndex !== this.maxIndex) {
						this.selectedIndex = this.selectedIndex + 1;
						this.scroll('down');
					}
					break;
				case 38: /* Arrow up */
					event.preventDefault();
					if (this.selectedIndex !== 0) {
						this.selectedIndex = this.selectedIndex - 1;
						this.scroll('up');
					}
					break;
				case 32: /* Space */
					event.preventDefault();
					this.selectItem(this.selectedIndex);
					break;
				case 27: /* Escape */
				case 13: /* Enter */
					this.toggleSelect();
					break;
				default:
					break;
			}
		},
		scroll(direction) {
			if (direction === 'up') {
				this.$refs.list.scrollTop -= 33;
			} else {
				this.$refs.list.scrollTop += 33;
			}
			this.scrollPos = this.$refs.list.offsetTop;
		}
	},
}
</script>
